import axios from "../../api/axiosInstance";
import { STATUS, extractErrorInfo } from "./sharedfunction";

/**
 * List the current user's linked Slack accounts (for two-way Slack chat identity)
 * GET /user/slack-links
 * @returns {Promise<Object>} Response object with status, data (array of links), and message
 */
export async function listSlackLinks() {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user/slack-links`,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    console.error("Error listing Slack links:", error);
    return extractErrorInfo(error);
  }
}

/**
 * Unlink a Slack account by id
 * @param {string} linkId - Slack link UUID
 * @returns {Promise<Object>} Response object with status, data, and message
 */
export async function unlinkSlackAccount(linkId) {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/user/slack-links/${linkId}`,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    console.error("Error unlinking Slack account:", error);
    return extractErrorInfo(error);
  }
}
